import { useMemo } from 'react';
import type { FormDescriptor } from '@finance/contracts';
import { resolveAction, type ResolvedAction } from './action-resolution';
import type { EvaluationContext } from '../conditions/evaluate-condition';

export interface UseFormActionsOptions {
  contract: FormDescriptor;
  formValuesWithIds: Record<string, unknown>;
  evalCtx: EvaluationContext;
  pending: boolean;
  isDirty: boolean;
  isValid: boolean;
}

export interface UseFormActionsResult {
  resolvedActions: ResolvedAction[];
  visibleActions: ResolvedAction[];
}

export function useFormActions({
  contract,
  formValuesWithIds,
  evalCtx,
  pending,
  isDirty,
  isValid,
}: UseFormActionsOptions): UseFormActionsResult {
  const resolvedActions = useMemo(() => {
    const evalValues: Record<string, unknown> = { ...formValuesWithIds };
    return contract.actions.map((a) =>
      resolveAction(
        a,
        contract,
        evalCtx,
        evalValues,
        contract.mode,
        pending,
        { isDirty, isValid },
      ),
    );
  }, [contract.actions, contract, evalCtx, formValuesWithIds, pending, isDirty, isValid]);

  const visibleActions = useMemo(() => resolvedActions.filter((ra) => ra.visible), [resolvedActions]);

  return { resolvedActions, visibleActions };
}
